import React from "react";

const Footer = () => {
  return (
    <div className="footer">
      <div className="copyright">
        <p>
          Copyright Vívaro Digital 2023
        </p>
      </div>
    </div>
  );
};

export default Footer;
